<template>
  <div id="login-wg" class="container login-wg">
    <form class="login" @submit.prevent="login">
      <div class="row">
        <h1><i class="fa fa-lock" aria-hidden="true"></i> Authentification</h1>
      </div>

      <div class="auth_indication_msg" :class="{ auth_error_msg: errored }">
        {{ message }}
      </div>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-user-tie"></i>
          </span>
        </div>
        <input
          type="email"
          class="form-control"
          placeholder="email"
          required
          v-model="email"
        />
      </div>
      <br />

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa fa-key icon"></i>
          </span>
        </div>
        <input
          required
          v-model="password"
          type="Password"
          name
          class="form-control"
          placeholder="password"
        />
      </div>
      <br />
      <br />
      <div class="checkbox">
        <!--
        <span class="float-left">
          <label>
            <input type="checkbox" value v-model="remember" /> Remember Me
          </label>
        </span>
       -->
        <span class="float-right">
          <a href="/users/forgotpassword">Forgot your password?</a>
        </span>
      </div>
      <br />
      <br />
      <br />
      <button :disabled="isDisabled" type="submit" class="form-control btn btn-success btn-login">
        <span v-show="!loading">Sign In</span>
        <b-spinner v-show="loading" variant="warning" label="Spinning" small />
      </button>
      <!--
      <br />
      <br />
      <center>
        <div style="border:1px solid black;height:1px;width:300px;"></div>
      </center>
      <br />
      <div class="footer">
        <p>
          Don't have an Account!
          <a href="#" @click="register">Sign Up Here</a>
        </p>
        <p>
          <a href="#">Forgot Password?</a>
        </p>
      </div>
      -->
      <!--
      <center>
        <div style="border:1px solid black;height:1px;width:300px;"></div>
      </center>
      <br />
      <div>
        <button @click="guestAccess" class="form-control btn btn-warning">
          Continue as a guest
        </button>
      </div>
      -->
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      errored: false,
      remember: false,
      email: "",
      password: "",
      message: "",
    };
  },
  computed: {
    isDisabled(){
      return this.loading;
    }
  },
  //created() {
  //  this.remember = localStorage.getItem("remember") == "true" ? true : false;
  //},
  methods: {
    login: function() {
      this.message = "";
      this.loading = true;
      let email = this.email;
      let password = this.password;
      let remember = this.remember;
      this.$store
        .dispatch("signIn", { email, password, remember })
        .then(() => {
          this.$store.dispatch("load_profile", this.$store.state.current_profile)
          .then(() => {
            this.loading = false;
            this.$router.push("/portal/dashboard");
          })
          .catch((error) => {
            this.loading = false;
            this.errored = true;
            this.message = error.response.data.fault.faultstring;
            this.message = "Could not load the profile";
          }); 
        })
        .catch((error) => {
          this.loading = false;
          this.errored = true;
          if(!error.response) {
            this.message = "No internet connection or DECSA server is temporarily unavailable"
          } else {
            this.message = "Wrong email or password"
          }
          //this.$toast.error(this.message, {
          //  position: "top",
          //});
        });
    },
    /*
    register: function () {
      this.$router.push("/users/register");
    },
    guestAccess: function () {
      this.$router.push("/portal/guest");
    },
    */
  },
};
</script>
